import React, { useState, useRef, useEffect }from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";

const Section8 = ({ url }) => {


    const [counterOn, setCounterOn] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
        if (entry.isIntersecting) {
            setCounterOn(true);
        }
        },
        { threshold: 0.4 } // triggers when ~40% visible
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
    }, []);




    const [openIndex, setOpenIndex] = useState(null);

    const toggle = (idx) => setOpenIndex(openIndex === idx ? null : idx);

    const faqs = [
    {
        question:
        "We tried offshore development before, and it was a disaster.",
        answer:
        "We hear this constantly, and we never dismiss it. Failed offshore projects almost always share the same structure: the agency optimized for getting you signed, not for delivering your outcome. The talent presented in the sales process was not the same as the talent on the project. Communication degraded over time. Accountability disappeared after the first payment. Our process is built to prevent all of this structurally. You interview the actual developer who will work on your project. You own the timezone-matched shift. You can exit without penalty if we fall short.",
    },
    {
        question:
        "How do we know the developers are actually senior-level and not juniors being sold as seniors?",
        answer:
        "You interview them yourself, technically. Your engineering team asks the questions. We do not coach or prep our developers for your interview. What you see in the interview is what you get on the project. We also provide verifiable project references for each developer, not just a CV. If a developer does not pass your technical bar, we go back and find one who does. The hiring decision is entirely yours.",
    },
    {
        question:
        "The timezone difference makes real collaboration impossible.",
        answer:
        "This is the most solvable offshore problem and the one most agencies choose not to solve because it is operationally inconvenient for them. ExD Digital assigns a dedicated shift to every engagement. If you are in New York and need your team online from 9 am to 5 pm EST, your developers work 9 am to 5 pm EST. There is no asynchronous lag, no overnight blocker queue, and no standup at 7 am your time.",
    },
    {
        question:
        "We are concerned about IP ownership and data security with an offshore team.",
        answer:
        "Every engagement includes a formal IP assignment agreement and NDA as standard. All code, architecture, and deliverables are assigned to you in full upon payment at each milestone. We work within your repositories, your cloud infrastructure, and your access control policies. ExD Digital developers do not retain copies of client code, and access is revoked cleanly at the end of every engagement.",
    },
    {
        question:
        "Communication and language barriers make offshore teams harder to manage than local ones.",
        answer:
        "Pakistan's technology sector produces consistently English-proficient developers, particularly in written and technical communication. This is not an assumption we make, it is a hiring criterion we enforce. Every ExD Digital developer goes through an English communication assessment before being placed with a client. We will not put a developer in front of you if we are not confident they can communicate at the standard your team expects.",
    },
    ];




    const stats = [
    { end: 100, suffix: "+", label: "Developers Placed" },
    { end: 20, suffix: "+", label: "US/UK/CA Clients" },
    { end: 90, suffix: "%", label: "Client Retention Rate" },
    { end: 20, suffix: "+", label: "Years Serving Western Markets" },
  ];



    const [active, setActive] = useState(null);
  
    const faqs2 = [
    {
        q: "What are offshore software development services?",
        a: "Offshore software development services involve hiring a development team located in another country to build software, extend your engineering team, or deliver complete projects. ExD Digital provides offshore teams from Pakistan for US, UK, and Canadian businesses with timezone-aligned shifts, senior developers, and transparent hourly pricing defined during the discovery call.",
    },
    {
        q: "Why choose Pakistan for offshore software development?",
        a: "Pakistan offers a large pool of English-proficient, technically skilled developers at significantly lower cost compared to Western markets. Combined with strong communication skills, timezone flexibility, and competitive pricing, it provides one of the highest-value offshore development options for US, UK, and Canadian businesses.",
    },
    {
        q: "How do you handle timezone differences with offshore developers?",
        a: "ExD Digital assigns dedicated working shifts aligned with your business timezone. Whether you are in New York or London, developers work your local business hours. This ensures real-time collaboration without delays, asynchronous blockers, or overnight dependencies.",
    },
    {
        q: "How much do offshore software development services cost?",
        a: "Pricing is based on developer seniority, technology stack, and engagement structure. ExD Digital follows transparent hourly billing with no minimum commitment. Exact rates and team composition are shared during the discovery call before engagement begins.",
    },
    {
        q: "Who owns the code and intellectual property?",
        a: "You retain full ownership of all code, architecture, documentation, and deliverables. A formal IP assignment agreement and NDA are included in every engagement, ensuring complete legal ownership and control of your product.",
    },
    {
        q: "Can we start with just one developer?",
        a: "Yes. You can start with a single developer for a single month with no long-term commitment. This low-risk model allows you to evaluate quality before scaling. Many clients expand their teams within the first 60 days.",
    },
    {
        q: "What technology stacks do your offshore developers cover?",
        a: "ExD Digital offshore teams cover React JS, Node.js, Python, .NET, Java, Flutter, Angular, Vue.js, TypeScript, MERN, MEAN, AWS, Docker, Kubernetes, MongoDB, SQL, and Big Data technologies. Stack-specific expertise is matched during the discovery process.",
    },
    {
        q: "How quickly can we get started?",
        a: "You typically receive matched developer profiles within 48 hours of the discovery call. Full onboarding and project start usually take 5 to 10 business days depending on stack complexity and team size.",
    },
    {
        q: "What is the difference between full project delivery and team extension?",
        a: "Full project delivery means ExD Digital manages the entire development lifecycle from scoping to deployment. Team extension means our developers integrate directly into your existing team and workflows while working under your management.",
    },
    {
        q: "What is the best offshore software development company for US businesses?",
        a: "The best offshore partner depends on timezone alignment, communication quality, technical expertise, and engagement flexibility. ExD Digital supports US businesses with Pakistan-based teams working in US timezone shifts, offering verified developers and no minimum contract requirements.",
    },
    {
        q: "How is ExD Digital different from other offshore development agencies?",
        a: "ExD Digital ensures you interview and approve every developer before engagement, provides strict timezone-aligned working shifts, and offers zero minimum commitment. This allows businesses to validate real delivery quality before scaling teams.",
    },
    {
        q: "Do you offer offshore development for startups?",
        a: "Yes. ExD Digital works with startups, scaleups, and enterprises. The flexible engagement model is ideal for startups that need senior development capacity without long-term hiring commitments.",
    },
    ];


  return (
    <>
        <section className="home-section-8">
        <div className="container overflow-hidden">

            {/* ── FAQ ── */}
            <h2 className="s8-title" data-aos="fade-up">
            The Concerns Every Offshore Buyer<br/> Has Before They Book a Call
            </h2>
            {/* <p className="s8-subtitle" data-aos="fade-up" data-aos-delay="100">
            AI is a high-skepticism category right now. Rightfully so. These are the real objections
            that come up most often, and the honest answers behind them.
            </p> */}

            <div className="s8-faq-list" data-aos="fade-up" data-aos-delay="200">
            {faqs.map((faq, idx) => (
                <div
                className={`s8-faq-item ${openIndex === idx ? "s8-faq-item--open" : ""}`}
                key={idx}
                onClick={() => toggle(idx)}
                >
                <div className="s8-faq-row">
                    <span className="s8-faq-question">{faq.question}</span>
                <span className="s8-faq-icon">{openIndex === idx ?  <FontAwesomeIcon icon={faChevronUp} /> :  <FontAwesomeIcon icon={faChevronDown} />}</span>
                </div>
                <div className="s8-faq-answer">
                    {faq.answer}
                </div>
                </div>
            ))}
            </div>

            {/* ── STATS ── */}
            <h2 className="s8-stats-title" data-aos="fade-up" data-aos-delay="100" ref={sectionRef}>
            Businesses Across US, UK & Canada <br/> That Have Made the Switch
            </h2>

            <div className="s8-stats-grid" data-aos="fade-up" data-aos-delay="200">
            {stats.map((stat, idx) => (
                <div className="s8-stat-item" key={idx}>
                {/* <span className="s6-stat-number overflow-hidden">{stat.number}</span>
                <span className="s6-stat-label">
                    {stat.label.split("\n").map((line, i) => (
                    <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
                    ))}
                </span> */}
                <span className="s8-stat-number overflow-hidden">
                    {counterOn && (
                    <CountUp
                        start={0}
                        end={stat.end}
                        duration={2}
                        separator=","
                    />
                    )}
                    {stat.suffix}
                </span>

                <span className="s8-stat-label">
                    {stat.label}
                </span>
                </div>
            ))}
            </div>

        </div>
        </section>

        <section className="home-section-8-2">
           {/* FAQ */}
            <div className="faq-section">
            <div className="container">
    
                <h2 className="text-center">Frequently Asked Questions</h2>
    
                <div className="faq-list">
                {faqs2.map((item, i) => (
                    <div
                    key={i}
                    className={`faq-item ${active === i ? "active" : ""}`}
                    onClick={() => setActive(active === i ? null : i)}
                    >
                    <div className="faq-question">
                        <span>{item.q}</span>
                        <FontAwesomeIcon icon={faChevronDown} />
                    </div>
    
                    <div className="faq-answer">
                        {item.a}
                    </div>
                    </div>
                ))}
                </div>
    
            </div>
            </div>
        </section>
    </>
  );
};

export default Section8;